/* istanbul ignore file */
export enum GridAction {
    None = 0,
    Add = 1,
    Delete = 2,
    Reorder = 3,
}
